import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const getVisitorId = (): string => {
  let id = localStorage.getItem("crestora_visitor_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("crestora_visitor_id", id);
  }
  return id;
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track dashboard/login pages
    if (location.pathname.startsWith("/login") || location.pathname.startsWith("/dashboard")) return;

    supabase.from("page_views").insert({
      page_path: location.pathname,
      visitor_id: getVisitorId(),
      user_agent: navigator.userAgent,
      referrer: document.referrer || null,
    });
  }, [location.pathname]);
};
